import PaymentDetails from "components/AgentPortal/PolicyDetails/AnnuitiesPolicyCards/PaymentDetails/PaymentDetails";

export default PaymentDetails;
